var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('top',{attrs:{"topIndex":0}}),_c('div',{staticClass:"mian",style:({ height: _vm.mianH + 'px' })},[_c('left',{attrs:{"leftIndex":0}}),_c('homeMain')],1),_c('RightDisplayArea'),_c('Welcome',{ref:"welcome"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }